import { Calendar, Wallet } from "lucide-react";

import { BarChartCard } from "./BarChartCard";
import { formatCount } from "./chartPalette";
import { DonutChartCard } from "./DonutChartCard";
import { ChartsGrid, InsightsPanel, StatsRow } from "./InsightsLayout";
import { StatCard } from "./StatCard";
import { TrendChartCard } from "./TrendChartCard";

export const AppointmentsInsights = ({ insights, isLoading }) => {
  const moneyOwedCount = insights?.moneyOwedCount ?? 0;

  return (
    <InsightsPanel>
      <StatsRow>
        <StatCard label="Total Appointments" icon={Calendar} isLoading={isLoading}
          value={formatCount(insights?.totalAppointments)} />
        <StatCard label="Money Owed" icon={Wallet} tone={moneyOwedCount > 0 ? "warning" : "neutral"} isLoading={isLoading}
          value={formatCount(moneyOwedCount)} />
      </StatsRow>
      <ChartsGrid>
        <DonutChartCard title="By Status" data={insights?.byStatus} isLoading={isLoading} />
        <BarChartCard title="By Doctor" data={insights?.byDoctor} isLoading={isLoading} />
        <TrendChartCard title="Appointments Over Time" data={insights?.trendByDay} isLoading={isLoading} />
      </ChartsGrid>
    </InsightsPanel>
  );
};
